




















































































import { Component } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { getCateList, getAccountList, accountDel } from '@/api/admin'
import AccountForm from './accountForm.vue'
import conFirm from './confirm.vue'

@Component({
  components: {
    AccountForm,
    conFirm
  }
})
export default class Account extends ViewBase {
  loading = true
  errMsg = ''
  total = 0
  page = 1
  pageSize = 10
  list = null
  editItem = {}
  delItem = {}
  editVisible = false
  delVisible = false
  title = ''
  resTypeList = []
  needStatus = ''
  phaseList = []
  subjectList = []
  dresType = {}
  dphase = {}
  dsubject = {}
  pagination: any = {}
  columns: any = []
  lang = {}

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  created() {

    this.lang = this.i18n.vAccount
    const lang: any = this.lang
    this.columns = [
      {
        title: lang.account,
        className: 'colName',
        dataIndex: 'username'
      },
      {
        title: lang.nickname,
        className: 'colNickname',
        dataIndex: 'nickname'
      },
      {
        title: lang.phaseOfStudy,
        dataIndex: 'phase_id',
        scopedSlots: { customRender: 'phaseid' }
        // className:css.colnum,
      },
      {
        title: lang.subject,
        dataIndex: 'subject_id',
        scopedSlots: { customRender: 'subjectid' }
      },
      {
        title: lang.createTime,
        className: 'wid185',
        dataIndex: 'create_time',
        scopedSlots: { customRender: 'createTime' }
      },
      {
        title: lang.operation,
        dataIndex: 'operation',
        className: 'texcenter wid260',
        scopedSlots: { customRender: 'operation' }
      }
    ]
    this.getType()
  }
  async getType() {
    try {
      const { data } = await getCateList()
      // console.log('获取学科接口', data)
      const resTypeList: any = []
      const dsubject: any = []
      const phaseList: any = []
      const dphase: any = []
      const dresType: any = []

      data.res_type.map((item: any) => {
        dresType[item.id] = item.name
        resTypeList.push(item)
      })
      data.phase.map((item: any) => {
        dphase[item.id] = item.name
        phaseList.push(item)
        item.subject.map((subject: any) => {
          dsubject[subject.id] = subject.name
        })
      })

      this.resTypeList = resTypeList
      this.dsubject = dsubject
      this.dphase = dphase
      this.dresType = dresType
      this.phaseList = phaseList
      this.fetch({
        page: 1
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }

  handleTableChange(pagination: any) {
    // console.log(pagination)
    const pager: any = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    this.fetch({
      page: pagination.current
    })
  }

  async fetch(params: any = {}) {
    // console.log('params:', params)
    this.loading = true

    try {
      const { data } = await getAccountList(params)

      const pagination: any = { ...this.pagination }
      // Read total count from server
      // pagination.total = data.totalCount;
      pagination.total = data.total
      this.loading = false
      this.list = data.list
      this.pagination = pagination
    } catch (ex) {
      this.handleError(ex)
    }
  }
  // 新增删除编辑等操作函数
  changegephase(subjectList: any, item: any) {
    this.editItem = item
    this.subjectList = subjectList
  }
  onAccountFormDone() {
    this.editVisible = false
    this.fetch({
      page: this.pagination.current || 1
    })
  }
  hideform() {
    this.editVisible = false
    this.editItem = {}
  }
  onCreate() {
    this.editItem = {}
    this.editVisible = true
  }
  onEdit(item: any) {
    // console.log(item)
    const id = item.phase_id
    let subjectList: any = []
    this.phaseList.forEach((element: any) => {
      if (element.id == id) {
        subjectList = element.subject
      }
    })
    const xxx: any = Object.assign({}, item)
    xxx.usernamexxx = item.username
    this.subjectList = subjectList
    this.editItem = xxx
    this.editVisible = true
  }
  onDel(item: any) {
    this.delItem = Object.assign({}, item)
    this.delVisible = true
  }
  cancelDel(item: any) {
    // console.log('quxiao')
    this.delItem = {}
    this.delVisible = false
  }

  async delAccount() {
    const delItem: any = this.delItem
    const pdata: any = {
      id: delItem.id
    }
    try {
      const res = await accountDel(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      this.delVisible = false
    } catch (ex) {
      this.handleError(ex)
    }
    this.fetch({
        page: this.pagination.current || 1
    })
  }
}
